import { render, staticRenderFns } from "./ApprovalFlow.vue?vue&type=template&id=547a0ccc&scoped=true&"
import script from "./ApprovalFlow.vue?vue&type=script&lang=js&"
export * from "./ApprovalFlow.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalFlow.vue?vue&type=style&index=0&id=547a0ccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a0ccc",
  null
  
)

export default component.exports